import {
  useState,
  useEffect,
  useContext,
  createContext,
  useDebugValue,
} from "react";
import useBRData from "./usebrdata";
import useTeam from "./useteam";
import useSquad from "./usesquad";
import useTeams from "./useteams";
import useLineUp from "./uselineup";

const DataContext = createContext();

function convertStringToObject(inputString) {
  const keyValuePairs = inputString.split("&");
  const result = {};

  for (let i = 0; i < keyValuePairs.length; i++) {
    const [key, value] = keyValuePairs[i].split("=");
    result[key] = value;
  }

  return result;
}

const DataContextProvider = ({ children }) => {
  const [accessKey, setAccessKey] = useState();
  const [memberId, setMemberId] = useState();
  const [teamId, setTeamId] = useState();

  useEffect(() => {}, [accessKey]);

  const { data: myDetails } = useBRData("m", { memberid: memberId }, accessKey);
  const { data: myTeamData } = useTeam(teamId, accessKey);
  const { data: mySquad } = useSquad(teamId, accessKey);
  const teamlist =  (myDetails && myDetails.members && myDetails.members[memberId]) ? myDetails.members[memberId].teams : [];
  const { data: lineup } = useLineUp(teamId, accessKey);

  const { data: myTeamList } = useTeams(teamlist, accessKey);

  useEffect(() => {
    console.log("Lineup", lineup)
  }, [lineup]);

  useEffect(() => {
    if (myDetails  && myDetails.members) {
      setTeamId(myDetails.members[memberId].main_teamid);
    }
  }, [myDetails]);

  useEffect(() => {
    if (accessKey && accessKey !== "undefined") {
      localStorage.setItem("accessKey", accessKey);

      let keyValue = convertStringToObject(accessKey);
      let mid = keyValue["m"];
      setMemberId(mid);
    }
  }, [accessKey]);

  useEffect(() => {
    // console.log("teamId", teamId)
  }, [teamId]);

  useEffect(() => {
    const key = localStorage.getItem("accessKey");
    if (key && key !== "undefined" && typeof key === "string") {
      setAccessKey(key);
    }
  }, []);

  return (
    <DataContext.Provider
      value={{ myDetails, teamId, setTeamId, lineup, myTeamData, myTeamList, mySquad, accessKey, setAccessKey }}
    >
      {children}
    </DataContext.Provider>
  );
};

const useDataContext = () => useContext(DataContext);

export { DataContextProvider, useDataContext };
